__turbopack_context__.v({
  "btn": "DownloadCV-module-scss-module__inRBHq__btn",
});
